module.exports = __webpack_public_path__ + "img/backyard-side-door.2db72e71.webp";